import { render, staticRenderFns } from "./scaleBoxControl.vue.js?vue&type=template&id=a807f930!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./scaleBoxControl.vue?vue&type=template&id=a807f930"
import script from "./scaleBoxControl.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./scaleBoxControl.vue?vue&type=script&lang=js"
export * from "./scaleBoxControl.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./scaleBoxControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports